
import React from "react";

const Insights = () => {
  return (
    <section id="insights" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Insights</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Strategic Perspectives on Enterprise AI
        </h2>
        <div className="row">
          <div className="col-md-12 text-center">
            <p className="text-5">This section is coming soon. I will be sharing my thoughts on enterprise AI challenges, opportunities, and strategic frameworks.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Insights;
